<div class="d-flex justify-content-center align-items-center w-100 my-5">
    <div class="spinner-border text-light spinner-style" role="status" >
    </div>
</div>